import { render, staticRenderFns } from "./DeliveryView.vue?vue&type=template&id=a1d8f1b8&scoped=true&"
import script from "./DeliveryView.vue?vue&type=script&lang=js&"
export * from "./DeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryView.vue?vue&type=style&index=0&id=a1d8f1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d8f1b8",
  null
  
)

export default component.exports